import {get,post} from '@/utils/request'

export const apiAddress = p => post('api/v1/users/my_address/address_edit_before', p);
export const apiAddress2 = p => get('api', p);
